import { render, staticRenderFns } from "./PengajuanPartner.vue?vue&type=template&id=fdddd1e2&scoped=true&"
import script from "./PengajuanPartner.vue?vue&type=script&lang=js&"
export * from "./PengajuanPartner.vue?vue&type=script&lang=js&"
import style0 from "./PengajuanPartner.vue?vue&type=style&index=0&id=fdddd1e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdddd1e2",
  null
  
)

export default component.exports